var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const ExclamationCircle = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-exclamation_circle ${className}`} {...other}>
      <g>
        <path d="M8 16A8 8 0 108 0a8 8 0 000 16zm0-1.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13zm.25-5a.5.5 0 00.492-.41L8.75 9 9 4a.5.5 0 00-.41-.492L8.5 3.5h-1a.5.5 0 00-.492.41L7 4l.25 5a.5.5 0 00.41.492l.09.008h.5zM8 12.64a1.07 1.07 0 100-2.14 1.07 1.07 0 000 2.14z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default ExclamationCircle;
